(function auditModuleDefinition() {
    'use strict';

    angular.module('EmployeeFileCertificate', ['ngFileUpload', 'ui.router', 'Config', 'Entities', 'CustomControls', 'ui.select', 'ui.selectExtend', 'TranslatedPaginator'
        , 'ClickOnce', 'FileDownloader', 'DoublyLinkedList'
    ])
        .config([
            'configProvider', '$stateProvider', 'loginProvider',
            function auditConfig(config, $stateProvider, loginProvider) {
                $stateProvider.state('employee-file-certificate-find', {
                    url: "/EmployeeFileCertificate/Find",
                    templateUrl: config.resourceUrl('/views/employee-file-certificate/employee-file-certificate-find.html'),
                    controller: 'EmployeeFileCertificateFindController',
                    authorize: true,
                    roles: loginProvider.roleCondition('CERTIFICATE READ')
                });

                $stateProvider.state('employee-file-certificate-detail', {
                    url: "/EmployeeFileCertificate/Detail/{userId}/{employeeFileId}",
                    templateUrl: config.resourceUrl('/views/employee-file-certificate/employee-file-certificate-detail.html'),
                    controller: 'EmployeeFileCertificateDetailController',
                    authorize: true,
                    roles: loginProvider.roleCondition('CERTIFICATE READ')
                });
            }
        ]);
})();
